<p-tree
  [value]="nodes"
  selectionMode="single"
  [(selection)]="selectedNode"
  (onNodeSelect)="onSelect($event)"
  (onNodeExpand)="onExpandedChange()"
  (onNodeCollapse)="onExpandedChange()"
  [loading]="loading"
  styleClass="mailbox-folder-tree">

  <ng-template let-node pTemplate="default">
    <div class="flex align-items-center gap-2 w-full folder-node" [class.folder-unread]="unreadOf(node.data) > 0">
      <i [class]="iconFor(node.data)"></i>
      <span class="folder-name">{{node.label}}</span>
      <span *ngIf="unreadOf(node.data) > 0" class="folder-count">{{unreadOf(node.data)}}</span>
    </div>
  </ng-template>
</p-tree>
